import { useEffect, useState } from 'react'
import { Button, Upload, Modal, List, Row, Col } from 'antd'
import { Loading } from 'Components'
import { UploadOutlined, FileOutlined, SyncOutlined } from '@ant-design/icons'
import { FileText, X } from 'react-feather'
import './UploadFileInput.scss'
import moment from 'moment'

export default UploadFileInput = ({ form, field, isCompact, disabled, ...props }) ->

  [uploadedFile, setUploadedFile] = useState(null)
  [visible, setVisible] = useState(false)
  [existingFiles, setExistingFiles] = useState([])
  [fetchingFiles, setFetchingFiles] = useState(true)
  [uploading, setUploading] = useState(false)

  useEffect(->
    (->
      setExistingFiles(await Weaver.File.list())
      setFetchingFiles(false)
    )()
    undefined
  , [])

  useEffect(->
    fileId = form?.getFieldValue(field)
    if fileId? and not _.isEmpty(existingFiles)
      weaverFile = existingFiles.find((f) -> f.id() is fileId)
      setUploadedFile(weaverFile.fileName)
    undefined
  ,[existingFiles])

  handleSetValue = (file) ->
    fieldValue = form.getFieldValue(field[0])
    newFieldValue = {
      fieldValue...,
      [field[1]]: file.id()
    }
    form.setFieldsValue({ [field[0]]: { newFieldValue... }})

  handleUpload = ({ file, onSuccess }) ->
    if file
      setUploading(true)
      try
        file.uploadTime = moment()
        weaverFile = new Weaver.File(file)
        fieldValue = form.getFieldValue(field[0])
        form.setFieldsValue({
          config: {
            fieldValue...,
            [field[1]]: weaverFile
          }
        })
        setUploadedFile(weaverFile.fileName)
        onSuccess()
        setUploading(false)
      catch e
        console.error e.message

  renderInnerContent = (Icon, text) ->
    <>
      <p className="ant-upload-drag-icon">
        <Icon />
      </p>
      <p className="ant-upload-text">{ text }</p>
    </>

  uploadDragger = (
    <Upload.Dragger
      data-testid="upload-file"
      customRequest={handleUpload}
      showUploadList={false}
      maxCount={1}
    >
      { renderInnerContent(UploadOutlined, "Click or drag file to this area to upload") }
    </Upload.Dragger>
  )

  fileSelector = (
    <div>
      <div
        className="ant-upload ant-upload-drag"
        onClick={-> setVisible(true)}
      >
        <div
          className="ant-upload-drag-container"
          style={{
            padding: "16px 0",
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          { renderInnerContent(FileOutlined, "Select from previously uploaded file") }
        </div>
      </div>
      <Modal
        title="Select a file"
        centered
        visible={visible}
        bodyStyle={{ height: "70vh" }}
        width={800}
        onOk={() -> setVisible(false)}
        onCancel={() -> setVisible(false)}
      >
        <List
          size="small"
          className="weaver-file-list"
          dataSource={existingFiles}
          renderItem={(file, i) ->
            <List.Item key="#{file.id()}-#{i}">
              <a
                onClick={() ->
                  handleSetValue(file)
                  setUploadedFile(file.fileName)
                  setVisible(false)
                }
              >
                {file.fileName}
              </a>
            </List.Item>
          }
        />
      </Modal>
    </div>
  )

  chooseFileUI = (
    <>
      <Col
        flex="auto"
        className="choose-file"
      >
        { uploadDragger }
      </Col>
      <Col
        flex="auto"
        className="choose-file"
      >
        { fileSelector }
      </Col>
    </>
  )

  uploadingFile = (
    <div
      style={{
        display: 'flex'
        width: '100%'
        padding: '20px'
        borderRadius: '9px'
        margin: '5px'
        border: '1px solid var(--borderColor)'
        alignItems: 'center'
        flexDirection: 'column'
      }}
    >
        <SyncOutlined spin />
        <p style={{ marginBottom: '0px' }}>Uploading file...</p>
    </div>
  )

  uploadedFileUI = (
    <>
      <Col
        flex="auto"
        className="uploaded-file"
      >
        <FileText size="48" strokeWidth="0.5px"/>
        <p>{ uploadedFile }</p>
      </Col>
      <Col flex="10px">
        <X
          onClick={(e)->
            form.setFieldsValue({ [field]: undefined })
            setUploadedFile(null)
          }
        />
      </Col>
    </>
  )

  compactUploader = (
    <>
      <Col style={{ flex: 3 }}>
        <Upload style={{ width: '100%' }}>
          <Button
            style={{ width: '100%' }}
            onClick={handleUpload}
            icon={<UploadOutlined />}
            disabled={uploading || disabled}
          >
            { if uploading then 'Uploading file...' else 'Click to upload file' }
          </Button>
        </Upload>
      </Col>
      <Col style={{ flex: 3 }}>
        <Button
          style={{ width: '100%' }}
          onClick={-> setVisible(true)}
          disabled={uploading || disabled}
        >
          Select existing file
        </Button>
        <Modal
          title="Select a file"
          centered
          visible={visible}
          bodyStyle={{ height: "70vh" }}
          width={800}
          onOk={() -> setVisible(false)}
          onCancel={() -> setVisible(false)}
        >
          <List
            size="small"
            className="weaver-file-list"
            dataSource={existingFiles}
            renderItem={(file, i) ->
              <List.Item key="#{file.id()}-#{i}">
                <a
                  onClick={() ->
                    handleSetValue(file)
                    setUploadedFile(file.fileName)
                    setVisible(false)
                  }
                >
                  {file.fileName}
                </a>
              </List.Item>
            }
          />
        </Modal>
      </Col>
    </>
  )

  compactUploaded = (
    <Col
      flex="auto"
      className="uploaded-file"
    >
      <p>{ uploadedFile }</p>
    </Col>
    <Col flex="10px">
      <X
        onClick={(e)->
          form.setFieldsValue({ [field]: undefined })
          setUploadedFile(null)
        }
      />
    </Col>
  )

  renderCompactInput = () ->
    <Row gutter={8}>
      {
        if uploadedFile?
          compactUploaded
        else
          compactUploader
      }
    </Row>

  renderExtendedInput = () ->
    <Row gutter={16}>
      {
        if uploading
          uploadingFile
        else if uploadedFile?
          uploadedFileUI
        else
          chooseFileUI
      }
    </Row>

  renderUi = () ->
    if isCompact then renderCompactInput() else renderExtendedInput()

  <div>
    { if fetchingFiles then <Loading style={{ display: 'flex', textAlign: 'center', width: '100%', height: '200px', alignItems: 'center', background: 'var(--background)' }}/> else renderUi() }
  </div>
